import React, { useState } from "react";
import { STATUS_IDS } from "../../../components/Utils";
import { DeviceFormMenu } from "../../../components/Buttons";

const UserDeviceFormMenu = (props) => {
  const { userDevice, disabled, isTask, isUserTask, ...rest } = props;

  const initialDevice = userDevice || {};
  const [isMacAddressSet] = useState(
    !!(initialDevice.macAddress && initialDevice.macAddress !== ""),
  );
  const [isMacAddressChanged, setIsMacAddressChanged] = useState(false);

  // const onMacAddressChanged = (value) => {
  //   const isMacSet = value !== "";
  //   const oldDevice = userDevice || {};
  //   const wasMacSet = !!(oldDevice.macAddress && oldDevice.macAddress !== "");
  //   setIsMacAddressChanged(
  //     isMacSet && value !== oldDevice.macAddress && wasMacSet,
  //   );
  // };

  if (!userDevice) return null;

  const isSaveable =
    !isTask &&
    (userDevice.status_id === 0 ||
      userDevice.status_id === STATUS_IDS.FINISHED) &&
    isMacAddressSet &&
    (!userDevice.account || userDevice.account === "");

  const isUpdateable =
    isUserTask ||
    (!isTask &&
      userDevice.status_id === STATUS_IDS.FINISHED &&
      isMacAddressSet &&
      isMacAddressChanged &&
      userDevice.account &&
      userDevice.account !== "");

  const isChangeable =
    isTask ||
    userDevice.status_id === 0 ||
    userDevice.status_id === STATUS_IDS.FINISHED;

  const isDeleteable =
    !isTask &&
    userDevice.status_id === STATUS_IDS.FINISHED &&
    isMacAddressSet &&
    userDevice.account &&
    userDevice.account !== "";

  return (
    <DeviceFormMenu
      {...rest}
      saveHidden={disabled || !isSaveable}
      updateHidden={disabled || !isUpdateable}
      changeHidden={disabled || !isChangeable}
      deleteHidden={disabled || !isDeleteable}
    />
  );
};

export default UserDeviceFormMenu;
